import * as React from 'react';
import { CheckboxButtonGroup, InlineText2 } from '@cian/ui-kit';
import { roomsOptions } from '../../containers/RoomsCheckbox/config';
import { ERoom } from '../../types/filter';
import * as filterStyles from '../Filters/Filters.css';

interface IRoomsCheckboxProps {
  rooms: ERoom[];
  onChange: (event: React.SyntheticEvent, rooms: ERoom[]) => void;
}

export function RoomsCheckbox({ rooms, onChange }: IRoomsCheckboxProps) {
  return (
    <>
      <InlineText2>Количество комнат</InlineText2>
      <div className={filterStyles['input__wrapper']}>
        <CheckboxButtonGroup options={roomsOptions} value={rooms} onChange={onChange} spliced />
      </div>
    </>
  );
}
